import { render } from "./EsimProfilesTableRow.vue?vue&type=template&id=04143840&ts=true"
import script from "./EsimProfilesTableRow.vue?vue&type=script&lang=ts"
export * from "./EsimProfilesTableRow.vue?vue&type=script&lang=ts"

import "./EsimProfilesTableRow.vue?vue&type=style&index=0&id=04143840&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__